import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useListNews } from "../hooks/useListNews";
import type { Post } from "../types/post";
import { NewsPost } from "./NewsPost";
import { SeeMoreLink } from "./common/SeeMoreLink";
import { SkeletonLoader } from "./common/SkeletonLoader";

export const NewsWrapper = () => {
  const { isLoading, data } = useListNews();
  const history = useHistory();

  const posts = (data?.records || []).slice(0, 2);

  return (
    <div className="mt-2">
      <div className="py-3">
        <Typography.BodySm weight="medium" color="text-tertiary">
          {t("help_widget.explore_page.news")}
        </Typography.BodySm>
      </div>
      <div>
        {isLoading ? (
          <SkeletonLoader
            rows={2}
            height="80px"
            wrapperClassName="px-2"
            loaderClassName="bg-primary"
          />
        ) : (
          posts.map((post: Post) => <NewsPost key={post.id} post={post} />)
        )}
      </div>
      <div className="pb-3 pt-2">
        <SeeMoreLink onClick={() => history.push("/news")} />
      </div>
    </div>
  );
};
